export class AuthCredentials {
  public email: string;
  public password: string;
}
